import { render, staticRenderFns } from "./place-card.vue?vue&type=template&id=e2061698&scoped=true&"
import script from "./place-card.vue?vue&type=script&lang=ts&"
export * from "./place-card.vue?vue&type=script&lang=ts&"
import style0 from "./place-card.vue?vue&type=style&index=0&id=e2061698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2061698",
  null
  
)

export default component.exports